module.exports = __webpack_public_path__ + "img/icon_footer_league_on.5ba49d90.svg";